<template>
  <div>
    <div class="d-flex justify-content-between align-items-center mb-4">
      <h4>{{ $t('schedules.add') }}</h4>
      <CButton color="secondary" @click="goBack">{{ $t('goBack') }}</CButton>
    </div>
    
    <ExperienceAvailabilitiesForm 
      @submit-requested="onSubmitRequested" 
      :loading="loading">
    </ExperienceAvailabilitiesForm>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import ExperienceAvailabilitiesForm from './ExperienceAvailabilitiesForm.vue';
import router from '@/router';

export default {
  components: { ExperienceAvailabilitiesForm },
  data() {
    return {
      loading: false
    };
  },
  computed: {
    ...mapState('experienceAvailabilities', ['createExperienceAvailabilityOutput'])
  },
  methods: {
    ...mapActions('experienceAvailabilities', ['create']),
    async onSubmitRequested(schedule) {
      this.loading = true;
      try {
        await this.create(schedule);
      } catch (error) {
        console.error('Error creating schedule:', error);
      } finally {
        this.loading = false;
      }
    },
    goBack() {
      router.push({ name: 'ExperienceAvailabilitiesList' });
    }
  },
  watch: {
    createExperienceAvailabilityOutput(val) {
      if (val) {
        this.loading = false;
      }
    }
  }
};
</script>

